import { render, staticRenderFns } from "./removeTeam.vue?vue&type=template&id=787d5f0c&scoped=true"
import script from "./removeTeam.vue?vue&type=script&lang=js"
export * from "./removeTeam.vue?vue&type=script&lang=js"
import style0 from "./removeTeam.vue?vue&type=style&index=0&id=787d5f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d5f0c",
  null
  
)

export default component.exports